(() => {
	var ArticlePopupOverlayFunc = (() => {
		var initialize = () => {
			console.log('Here is the popup button event---------');
			var overlay = document.getElementById('sales-landing-video-popup-overlay');
			var closeBtn = document.querySelector('#sales-landing-video-popup-overlay .slvp-close-icon');
			// var openBtn = document.getElementById('apo-popup-open');
	
			if (overlay) {
				var open = () => {
					overlay.classList.add('is-open');
					overlay.setAttribute('aria-hidden', 'false');
				}
	
				var close = () => {
					overlay.classList.remove('is-open');
					overlay.setAttribute('aria-hidden', 'true');
				}
	
				// Open on button click
				document.querySelectorAll('.hero-peters-story .text-wrapper .button').forEach((element) => {
					element.addEventListener('click', (e) => {
						e.preventDefault();
						open();
					})
				})
				// if (openBtn) {
				// 	openBtn.addEventListener('click', (e) => {
				// 		e.preventDefault(); 
				// 		open();
				// 	});
				// }
	
				// Close on close button click
				if (closeBtn) {
					closeBtn.addEventListener('click', close);
				}
	
				// Close on overlay background click
				overlay.addEventListener('click', e => {
					if (e.target === overlay) close();
				})
	
				// Close on Escape key
				document.addEventListener('keydown', e => {
					if (e.key === 'Escape') close();
				})
			}
		}
		return {
			init: initialize
		}
	})();

	document.addEventListener("DOMContentLoaded", () => {
		ArticlePopupOverlayFunc.init();
	})
})()
